module.exports = __webpack_public_path__ + "img/travel_step2.ac092ed5.svg";